import React, { useState } from 'react';

interface BorderedInputProps {
    id: string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    type?: string;
    icon: React.ReactNode;
    rightAdornment?: React.ReactNode;
    hasError?: boolean;
    autoComplete?: string;
}

const BorderedInput: React.FC<BorderedInputProps> = ({
    id,
    value,
    onChange,
    placeholder,
    type = 'text',
    icon,
    rightAdornment,
    hasError = false,
    autoComplete
}) => {
    const [isFocused, setIsFocused] = useState(false);

    const borderColor = hasError ? '#dc2626' : isFocused ? '#6366f1' : '#e5e7eb';
    const ringColor = hasError ? 'rgba(220, 38, 38, 0.15)' : 'rgba(99, 102, 241, 0.15)';

    const wrapperStyle: React.CSSProperties = {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        background: '#ffffff',
        border: `1px solid ${borderColor}`,
        borderRadius: '10px',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        boxShadow: isFocused || hasError ? `0 0 0 3px ${ringColor}` : 'none',
        boxSizing: 'border-box'
    };

    const inputStyle: React.CSSProperties = {
        flex: 1,
        border: 'none',
        outline: 'none',
        padding: '12px 14px 12px 0',
        fontSize: '15px',
        background: 'transparent',
        color: '#111827',
        minWidth: 0
    };

    const iconStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 12px',
        color: hasError ? '#dc2626' : '#9ca3af',
        fontSize: '16px'
    };

    return (
        <div style={wrapperStyle}>
            <span style={iconStyle}>{icon}</span>
            <input
                id={id}
                type={type}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                placeholder={placeholder}
                style={inputStyle}
                autoComplete={autoComplete}
            />
            {rightAdornment && (
                <span style={{ ...iconStyle, paddingRight: '12px' }}>{rightAdornment}</span>
            )}
        </div>
    );
};

export { BorderedInput };
